import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
  FormGroup,
  FormControlLabel,
  Checkbox
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import axios from "../../../lib/axios";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import checkAndLock from "../../../GlobalFunction/checkAndLock";
import UnLock from "../../../GlobalFunction/UnLock";
import CrudButtons from '../../../GlobalFunction/CrudButtons';
// import { useModulePermissions } from '../../../GlobalFunction/useModulePermissions';
import ReportTable from '../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';

const columns = [
  { id: 'RowNum', label: 'S.No.', minWidth: 170 },
  { id: 'AmenityName', label: 'Amenity', minWidth: 170 },
  { id: 'Amenity_Desc', label: 'Description', minWidth: 170 },
  { id: 'AreaSqFt', label: 'AreaSqFt', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 170 }
];

const AmenityMaster = () => {

  const [formData, setFormData] = useState({
    AmenityName: '',
    Amenity_Desc: '',
    FloorName: '',
    AreaSqFt: '',
    Remark: '',
    Photo: ''
  });

  // const permissions = useModulePermissions("Amenities Master");

  const [error, setError] = useState({
    amenityName: false,
    amenity_Desc: false
  });

  const navigate = useNavigate();

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const location = useLocation();
  const [currentAmenityId, setCurrentAmenityId] = useState(null);
  const [mode, setMode] = useState('view');
  const [floors, setFloors] = useState([]);
  const [lastInsertedAmenityId, setLastInsertedAmenityId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [Status, setStatus] = useState("1");
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);
  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const amenityNameRef = useRef(null);
  const amenity_DescRef = useRef(null);
  const areaSqFtRef = useRef(null);
  const remarkRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();

      const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
          reader.onloadend = () => {
            resolve(reader.result);
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };

      readFileAsBase64(file)
        .then(base64String => {
          setFormData(prevData => ({
            ...prevData,
            Photo: base64String
          }));
        })
        .catch(err => {
          console.error('Error reading file:', err);
          toast.error('Error reading file. Please try again.');
        });
    }
  };


  useEffect(() => {
    if (location.state && location.state.AmenityId) {
      setCurrentAmenityId(location.state.AmenityId);
      fetchAmenityMasterData(location.state.AmenityId);
      setMode('view');
    } else {
      setMode('add');
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchAmenityMasterData = async (id, flag) => {

    try {
      const response = await axios.post(`AmenityMst/RetriveAmenityMst`, {
        AmenityId: parseInt(id),
        Flag: flag
      });

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const amenityData = response.data.Data[0];
        setFormData({
          AmenityName: amenityData.AmenityName,
          Amenity_Desc: amenityData.Amenity_Desc,
          Remark: amenityData.Remark,
          FloorName: 1,
          AreaSqFt: amenityData.AreaSqFt,
          Photo: amenityData.Photo
        });
        setStatus(amenityData.Status.toString() || "0");
        setIsFormDisabled(true);
        setCurrentAmenityId(amenityData.AmenityId);
      } else if (response.data.Status === 1 && response.data.responseStatusCode === 2) {
        toast.info(response.data.Message);
      } else {
        toast.error('Failed to fetch AmenityMaster data');
      }
    } catch (error) {
      console.error('Error fetching AmenityMaster data:', error);
      toast.error('Error fetching AmenityMaster data. Please try again.');
    }
  };

  useEffect(() => {
    const getRow = async () => {
      const params = {
        start: 1,
        PageSize: 1,
        SearchText: ""
      };
  
      try {
        const res = await axios.post('AmenityMst/getAllAmenityMstDashBoard', { params });
  
        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
  
    getRow();
  }, []);

  useEffect(() => {
    const fetchFloors = async (flag) => {
      try {
        const response = await axios.post(`FloorMst/getFloorMstdrp`, {
          Flag: flag
        });
        if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
          setFloors(response.data.Data);
        } else {
          toast.error('Failed to fetch Floors');
        }
      } catch (error) {
        console.error('Error fetching Floors:', error);
        toast.error('Error fetching Floors. Please try again.');
      }
    };

    fetchFloors();
  }, []);

  const handlePrevious = async () => {
    if (currentAmenityId && currentAmenityId > 1) {
      await fetchAmenityMasterData(currentAmenityId, "P");
    }
  };

  const handleNext = async () => {
    if (currentAmenityId) {
      await fetchAmenityMasterData(currentAmenityId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));


    if (name === 'amenityMaster') {
      setFormData(prevState => ({
        ...prevState,
        state: ''
      }));
    }

    if (name === 'amenityMaster' && value !== '') {
      setTimeout(() => {
        remarkRef.current.focus();
      }, 100000);
    }
  };

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      if (event.target === amenityNameRef.current) {
        amenity_DescRef.current.focus();
      } else if (event.target === amenity_DescRef.current) {
        areaSqFtRef.current.focus();
      } else if (event.target === areaSqFtRef.current) {
        remarkRef.current.focus();
      } else {
        remarkRef.current.focus();
      }
    }
  };

  const handleSave = async () => {

    let hasError = false;

    if (!formData.AmenityName) {
      toast.error('Amenity Name is required');
      setError(prev => ({ ...prev, amenityName: true }));
      hasError = true;
    } else {
      setError(prev => ({ ...prev, amenityName: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        AmenityName: formData.AmenityName,
        Amenity_Desc: formData.Amenity_Desc,
        FloorId: 1,
        AreaSqFt: formData.AreaSqFt || 0,
        Remark: formData.Remark,
        Photo: formData.Photo,
        Status: Status
      };

      let response;
      if (mode === 'edit') {
        payload.AmenityId = currentAmenityId;
        payload.UpdatedBy = parseInt(UserId, 10);
        response = await axios.patch(`AmenityMst/UpdateAmenityMst`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`AmenityMst/InsertAmenityMst`, payload);
      }

      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        toast.success(response.data.Message);
        if (mode === 'add') {
          setLastInsertedAmenityId(response.data.Data)
          await fetchAmenityMasterData(response.data.Data);

          setMode('view');
          setIsFormDisabled(true);
          setCurrentAmenityId(response.data.Data);
        } else {
          setMode('view');
        }
        setIsFormDisabled(true);
      } else {
        toast.error(response.data.Message || 'Operation failed');
      }
    } catch (error) {
      console.error('Error saving/updating AmenityMaster:', error);
      toast.error('Error saving/updating AmenityMaster. Please try again.');
    }
  };

  const handleEdit = async () => {

    let Flag = await checkAndLock(currentAmenityId, "MstAmenity", "AmenityId");
    switch (Flag) {
      case 0:
        setMode("edit");
        setIsFormDisabled(false);
        break;
      case 1:
        toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2:
        toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default:
        toast.info("Something Went Wrong", { autoClose: 500 });
    }
  };

  const handleAdd = () => {
    setMode('add');
    setIsFormDisabled(false);
    setFormData({
      AmenityName: '',
      Amenity_Desc: '',
      Remark: '',
      AreaSqFt: '',
      FloorName: '',
      Photo: ''
    });
    setCurrentAmenityId(null);

    setTimeout(() => {
      amenityNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    try {
      await fetchAmenityMasterData(1, "L");
      await UnLock(currentAmenityId, "MstAmenity", "AmenityId");
      setMode('view');
      setIsFormDisabled(true);
    } catch (error) {
      toast.error('Error occurred while cancelling. Please try again.');
    }
  };

  const resetForm = () => {
    setFormData({
      AmenityName: '',
      Amenity_Desc: '',
      Remark: '',
      AreaSqFt: '',
      FloorName: '',
      Photo: ''
    });
    setCurrentAmenityId(null);
    setMode('view');
  };

  const handleExit = () => {
    navigate('/amenitytable')
  }

  const handleDeleteClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  const handleConfirmDelete = async () => {

    let Flag = await checkAndLock(currentAmenityId, "MstAmenity", "AmenityId");
    switch (Flag) {
      case 0:
        setOpenConfirmDialog(false);
        await fetchAmenityMasterData(currentAmenityId, "D");
        await fetchAmenityMasterData(currentAmenityId, "N");
        setMode('view');
        setIsFormDisabled(true);
        break;
      case 1: toast.info("Record  Already Locked", { autoClose: 500 });
        break;
      case 2: toast.info("Record Failed To Locked", { autoClose: 500 });
        break;
      default: toast.info("Something Went Wrong", { autoClose: 500 });

    }

  };

  return (
    <>

      <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>

        <ToastContainer />
        <Grid container spacing={2} className='form_grid'>
          <Grid item xs={12} className='form_title' 
            sx={{ display: 'flex', alignItems: 'center', 
                  justifyContent: 'space-between', marginTop: '20px',
                  flexDirection: { xs: 'column', sm: 'row', md: 'row' }  
                }}
              >
            <Grid
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', sm: 'flex-start' },
                marginBottom: { xs: '10px', sm: 0 }
              }}
            >
              <Button
                variant="contained"
                size="small"
                className='three-d-button-previous'
                onClick={handlePrevious}
                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentAmenityId || currentAmenityId === 1}
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                // sx={{ margin: '0px 10px' }}
                className='three-d-button-next'
                onClick={handleNext}
                sx={{ backgroundColor: '#635BFF', display: { xs: 'none', sm: 'block' } }}
                disabled={mode !== 'view' || !currentAmenityId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            
            <Typography
              variant="h5"
              sx={{
                margin: 'Auto',
                textAlign: { xs: 'center', sm: 'center' },
                fontSize: { xs: '24px', sm: '18px', md: '24px' }
              }}
            >
              Amenity Master
            </Typography>

            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName={"Amenities Master"}
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onView={handlePrint}
                onDelete={handleConfirmDelete}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={isFormDisabled}
              />
            </Grid>
          </Grid>


          <Grid item lg={8} md={8} xs={12}>
            <Box display="flex" flexDirection="column" gap={2}>
              <Grid item lg={12} md={12} xs={12}>

                <Box display="flex" flexDirection="column" gap={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6} lg={6}>
                      <TextField
                        id="AmenityName"
                        name="AmenityName"
                        label={
                          <span>
                            Amenity Name <span style={{ color: 'red' }}>*</span>
                          </span>
                        }
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        value={formData.AmenityName}
                        onChange={handleInputChange}
                        disabled={isFormDisabled}
                        error={error.amenityName}
                        helperText={error.amenityName && ""}
                        inputRef={amenityNameRef}
                        onKeyDown={handleKeyPress}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}>
                      <TextField
                        id="Amenity_Desc"
                        name="Amenity_Desc"
                        label="Description"
                        variant="filled"
                        fullWidth
                        className="custom-textfield"
                        value={formData.Amenity_Desc}
                        onChange={handleInputChange}
                        disabled={isFormDisabled}
                        error={error.amenity_Desc}
                        helperText={error.amenity_Desc && ""}
                        inputRef={amenity_DescRef}
                        onKeyDown={handleKeyPress}
                      />
                    </Grid>
                  </Grid>
                </Box>

              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={6} className='form_field'>
                  <TextField
                    id="AreaSqFt"
                    name="AreaSqFt"
                    label="AreaSqFt"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={formData.AreaSqFt}
                    onChange={handleInputChange}
                    disabled={isFormDisabled}
                    error={error.areaSqFt}
                    helperText={error.areaSqFt && ""}
                    inputRef={areaSqFtRef}
                    onKeyDown={handleKeyPress}
                  />
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <TextField
                    id="Remark"
                    name="Remark"
                    label="Remark"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={formData.Remark}
                    onChange={handleInputChange}
                    disabled={isFormDisabled}
                    error={error.remark}
                    helperText={error.remark && ""}
                    inputRef={remarkRef}
                  />
                </Grid>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={3} >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            disabled={isFormDisabled}
                            checked={Status === "1"}
                            onChange={handleChangeStatus}
                            style={{ marginLeft: '16px' }}
                          />
                        }
                        label="Status"
                      />
                    </FormGroup>
                  </Grid>
                </Grid>
              </Grid>

            </Box>
          </Grid>
          <Grid item lg={4} md={4} xs={12} display="flex" alignItems="center" justifyContent="center">
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              gap={2}
              border="1px solid #ccc"
              borderRadius={1}
              width={130}
              height={150}
              overflow="hidden"
              position="relative"
            >
              {formData.Photo ? (
                <img
                  src={formData.Photo}
                  alt="Uploaded Preview"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              ) : (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ textAlign: 'center' }}
                >
                  Photo
                </Typography>
              )}
            </Box>
            <input
              accept="image/*"
              style={{ display: 'none' }}
              disabled={isFormDisabled}
              id="upload-photo"
              type="file"
              onChange={handleFileChange}
            />
            <label htmlFor="upload-photo">
              <Button
                component="span"
                style={{ marginTop: '5px' }}
              >
                Upload Image
              </Button>
            </label>
          </Grid>

          <Grid item xs={12} className="form_button">
            {mode === 'view' && (
              <>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === 'edit' || mode === 'add') && (
              <>

                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSave}>
                  Submit
                </Button>
                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                  Cancel
                </Button>

              </>
            )}
          </Grid>
        </Grid>
      </Box>

      <div style={{ display: 'none' }}>
        {Object.keys(DataForPrint).length > 0 && <ReportTable
          columns={columns}
          rows={rows}
          title="Amenity Master"
          contentRef={contentRef}
          customStyles={{ backgroundColor: '#f5f5f5' }}
        />
        }
      </div>

      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Confirm Deletion"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: '#1565c0',
                color: 'white'
              }
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default AmenityMaster